import Model from '../models/model';

const model = new Model({
	name: 'CycleActionStatus',
	gridTitle: 'CycleActionStatus',
	api: 'CycleActionStatus',
	idProperty: 'CycleActionStatusId',
	defaultSort: 'DisplayValue',
	formTitleField: 'DisplayValue',
	title: 'CycleActionStatus',
	showGridRefreshBtn: true,
	initialValues: {
		IsActive: true
	},
	columns: [
		{ header: 'UniqueId', field: 'CycleActionStatusId', keyColumn: true, width: 120, hidden: true },
		{ header: 'LookupName', field: 'DisplayValue', width: 180, required: true, minLength: 2, maxLength: 50, inlineLabelSize: 2 },
		{ header: 'Active', field: 'IsActive', type: 'bool', width: 120, inlineLabelSize: 2 }
	]
});

export default model.createFormBase();